var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fieldset",
    { staticClass: "itinerary-selection__timeslot" },
    [
      _c(
        "legend",
        { staticClass: "sr-only", attrs: { id: "timeslot-list-label" } },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.tc("spaSoft.step1.itinerarySelection.title")) +
              "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.availableItinerary, function (timeslot, index) {
        return _c("TimeslotItem", {
          key: "timeslot-" + index,
          attrs: { data: timeslot, index: index },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }